import React, { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { CalendarInput } from '../../UI';
import { PropTypes } from 'prop-types';
import moment from 'moment-jalaali';
import LanguageContext from '../../../contexts/languageContext';
import { makeStyles } from '@material-ui/core';

// const pToe = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

const styles = makeStyles({
    datePickerContainer: {
        width: ({ isRtl }) => (isRtl ? '240px' : '280px')
    }
});
const RangeDatePicker = ({ value, setValue, maxDate }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ isRtl: lang === 'fa' });
    const now = moment(new Date()).format(lang === 'fa' ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD');

    return (
        <>
            <div className={classes.datePickerContainer}>
                <CalendarInput
                    width="100%"
                    isLeft
                    rangeValue={value}
                    isRangePicker
                    onChange={setValue}
                    min={value[0]?.format()}
                    max={maxDate && maxDate < now ? maxDate : now}
                    placeholder={messages.lastWeek}
                    usePortal
                />
            </div>
        </>
    );
};
RangeDatePicker.propTypes = {
    value: PropTypes.array,
    setValue: PropTypes.function,
    maxDate: PropTypes.string
};

export default RangeDatePicker;
